(function () {
    "use strict";

    Controllers.SchedulingController = class SchedulingController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, AnalyticsService, AppStates, UIUtils, SchedulingService, UsersManager, moment, PopupMessageService) {
            super($scope, $injector);
            this.__objectType = 'SchedulingController';

            this.AnalyticsService = AnalyticsService;
            this.AppStates = AppStates;
            this.SchedulingService = SchedulingService;
            this.UsersManager = UsersManager;
            this.moment = moment;
            this.PopupMessageService = PopupMessageService;

            this.AnalyticsService.trackPageView(this, 'Scheduling View');

            this.SESSION_TYPES_COUNT_LIMIT = 20;

            // get user
            this.user = this.UsersManager.getCurrUser();
            this.company = this.user.company;

            // set team members
            this.initTeamMembers();

            // load sessions
            this.loadSessionsData();

            // set calendar as the active route
            $scope.calendarAbstractVm.setSchedulingActive();
        }

        initTeamMembers() {
            this.teamMembers = this.company.getAllCompanyMembers();
            if(this.teamMembers.length > 1) {
                this.teamMembers = this.teamMembers.filter((tm) => !!tm.full_name);

                const currTeamMember = this.teamMembers.filter((tm) => tm._id === this.user._id)[0];
                const idx = this.teamMembers.indexOf(currTeamMember);
                if(idx > 0) {
                    this.teamMembers.splice(idx, 1);
                    this.teamMembers.unshift(currTeamMember);
                }

                this.currentViewingUser = this.teamMembers[0];
            }

            this.canViewOtherTeamMembers = this.user.hasCompanyAdminPermissions();
            this.isViewingCurrentUser = true;
        }

        loadSessionsData() {
            let forUserId;
            this.loadingSessions = true;
            if(this.canViewOtherTeamMembers &&
                this.currentViewingUser &&
                this.currentViewingUser._id &&
                this.currentViewingUser._id !== this.user._id) {
                forUserId = this.currentViewingUser._id;
            }

            return this.user.getSessions(forUserId, null, false, true).then((sessions) => {
                this.sessionsList = sessions.reverse().sort((sessionA, sessionB) => sessionA.enabled == sessionB.enabled ? sessionA : (sessionA.enabled ? -1 : 1));
                this.enabledSessionsList = this.sessionsList.filter((s) => s.enabled);

                // change empty state data
                this.sessionsEmptyText = this.isViewingCurrentUser ? 'SCHEDULING._HERO_TEXT_' : 'SCHEDULING._HERO_TEXT_OTHER_USER_';
                this.availabilityEmptyText = this.isViewingCurrentUser ? 'SCHEDULING._AVAILABILITY_EMPTY_STATE_TEXT_' : 'SCHEDULING._AVAILABILITY_EMPTY_STATE_TEXT_OTHER_USER_';

                this.loadingSessions = false;
            });
        }

        updateSession(session) {
            this.user.updateSession(session);
            this.enabledSessionsList = this.sessionsList.filter((s) => s.enabled);
        }

        createSession() {
            // limit for now
            if(this.sessionsList.length < this.SESSION_TYPES_COUNT_LIMIT) {
                this.$state.go(this.AppStates.root_core_sessionConfig, { sessionId: 'new' });
            } else {
                this.PopupMessageService.showAlertPromise(
                    this.PopupMessageService.severityTypes.none,
                    "Sorry, you can't create more than " + this.SESSION_TYPES_COUNT_LIMIT + " sessions.",
                    'OK',
                    'Create new session');
            }
        }

        onAvailabilityChange(session) {
            this.updateSession(session);
        }

        onChangeTeamMember(member) {
            this.currentViewingUser = member;
            this.isViewingCurrentUser = this.user._id === member._id;
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.select_team_member_scheduling);
            this.loadSessionsData();
        }
    };

}());
